var Repository    = require("app/Domain/Ott/Api/V2/Repository"),
    config        = require("app/config"),
    get           = require("object-path").get,
    kind          = require("enyo/kind"),
    logger        = require("enyo/logger"),
    quickMacroize = require("enyo/macroize").quickMacroize;

/**
 * This object retrieves Upgrade Offer items from the API.
 */
module.exports = kind.singleton(/** @lends app.Domain.Ott.Api.V2.DataAccess.Upgrade.Repository.prototype */ {

    /**
     * @private
     */
    name: "app.Domain.Ott.Api.V2.DataAccess.Upgrade.Repository",

    /**
     * @private
     */
    kind: Repository,

    // API
    // --------------------------------

    /**
     * @param    {boolean}  skipCache  Whether to skip the cache
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    getUpgrades: function(skipCache) {
        var key      = ["registration", "upgrade-request"].join("/"),
            lifetime = get(config, "cache.domain/ott/api/v2/registration/upgrade-request", 0),
            task     = this.tasks[key],
            endpoint;

        if (this.cache.isset(key) && !skipCache) {
            return Promise.resolve(this.cache.get(key));
        }

        // Start loading
        if (!task) {
            endpoint = new URL(quickMacroize("{$ottApi}/registration/upgrade-request", {
                ottApi: config.ottApi.url
            }));

            task = this.tasks[key] = this._get(endpoint);

            task.promise
                .then(this.bindSafely(function(response) {
                    if (response.status === "ok") {
                        this.cache.set(key, response, lifetime);
                    }

                    return response;
                }))
                .catch(this.bindSafely(function(error) {
                    logger.error(error);

                    if (typeof Sentry !== "undefined" && error instanceof Error) {
                        Sentry.captureException(error);
                    }

                    return Promise.resolve({
                        status: "rejected",
                        type:   "task_rejected",
                        error:  error
                    });
                }))
                .finally(this.bindSafely(function() {
                    delete this.tasks[key];
                }));
        }

        return task.promise;
    }

});
